import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import MultiValueSearchDropdown from '../MultiValueSearchDropdown';

const CountrySelectionModal = ({ show, onHide, countryMap, initialRedCountries, initialBlueCountries, onSave }) => {
    const [selectedRed, setSelectedRed] = useState([]);
    const [selectedBlue, setSelectedBlue] = useState([]);

    // Generate options from the map: { value: code, label: name }
    const countryOptions = Object.entries(countryMap).map(([code, name]) => ({ value: code, label: name }));

    // Map initial country codes to {value, label} format
    const mapCodesToOptions = useCallback((codes) => {
        return codes?.map(code => ({ value: code, label: countryMap[code] || code })) || [];
    }, [countryMap]);

    useEffect(() => {
        if (show) {
            setSelectedRed(mapCodesToOptions(initialRedCountries));
            setSelectedBlue(mapCodesToOptions(initialBlueCountries));
        }
    }, [show, initialRedCountries, initialBlueCountries, countryMap, mapCodesToOptions]);

    const handleSave = () => {
        const redValues = selectedRed.map(option => option.value);
        const blueValues = selectedBlue.map(option => option.value);
        onSave(redValues, blueValues);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton data-bs-theme="dark" className="bg-dark text-white">
                <Modal.Title className="text-white">Edit Country Assignments</Modal.Title>
            </Modal.Header>
            <Modal.Body data-bs-theme="dark" className="bg-dark text-white">
                <div className="mb-3">
                    <label htmlFor="modalRedCountriesSelect" className="form-label text-white">Red Countries</label>
                    <MultiValueSearchDropdown
                        id="modalRedCountriesSelect"
                        options={countryOptions} // Use generated options
                        value={selectedRed}
                        onChange={setSelectedRed}
                        placeholder="Select Red countries..."
                    />
                </div>
                <div>
                    <label htmlFor="modalBlueCountriesSelect" className="form-label text-white">Blue Countries</label>
                    <MultiValueSearchDropdown
                        id="modalBlueCountriesSelect"
                        options={countryOptions} // Use generated options
                        value={selectedBlue}
                        onChange={setSelectedBlue}
                        placeholder="Select Blue countries..."
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

CountrySelectionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    countryMap: PropTypes.objectOf(PropTypes.string).isRequired, // Changed from allCountries array to countryMap object
    initialRedCountries: PropTypes.arrayOf(PropTypes.string),
    initialBlueCountries: PropTypes.arrayOf(PropTypes.string),
    onSave: PropTypes.func.isRequired,
};

export default CountrySelectionModal; 